import { Modal, Button, ModalProps } from "react-bootstrap";

export default function ViewOutputModal({ raw, ...props }: { raw?: string } & ModalProps) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    View Output
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <pre>{raw}</pre>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}
